import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "radiologistAvailabilityScreen.ConflictAlert.title",
    defaultMessage: "Read Cutoff Time Conflict",
  },
  description: {
    id: "radiologistAvailabilityScreen.ConflictAlert.description",
    defaultMessage: "Are you sure you want to save these changes?",
  },
  warningText: {
    id: "radiologistAvailabilityScreen.ConflictAlert.warningText",
    defaultMessage:
      "The following cutoff times conflict with existing appointments containing a STAT add-on:",
  },
  conflictItem: {
    id: "radiologistAvailabilityScreen.ConflictAlert.conflictItem",
    defaultMessage: "Dr. {firstName} {lastName} \u2014 {date} at {time}",
  },
  btnEdit: {
    id: "radiologistAvailabilityScreen.ConflictAlert.btnEdit",
    defaultMessage: "Edit",
  },
  btnSave: {
    id: "radiologistAvailabilityScreen.ConflictAlert.btnSave",
    defaultMessage: "Save Cutoff Times",
  },
});

export default messages;
